import React from 'react';
import { Sidebar } from './components/Sidebar';
import { Dashboard } from './components/Dashboard';
export function App() {
  return <div className="min-h-screen bg-[#0a0a0a]" data-id="element-0">
      <Sidebar data-id="element-1" />
      <Dashboard data-id="element-2" />
    </div>;
}